export const Languages = (api) => ({
  get() {
    return api.get('/v1/languages')
  }
})
